module.exports = "<div [ngClass]=\"getNotificationClasses()\">\n    <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/modules/login/notification/notification.template.html
// module id = 873
// module chunks = 0